import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { StoresSection } from "@/components/ui/sections/StoresSection";
import type { StoriesRoute } from "@/data/routes/stories.route";
import type { StoresSectionStoryblok } from "@/generated/sb/sb-types";

export const StoresSectionBlok = ({
  blok,
  data,
}: BlokProps<StoresSectionStoryblok, StoriesRoute["storesSection"]>) => {
  return (
    <BlokWrap editable={blok}>
      <StoresSection
        caption={blok.caption || undefined}
        heading={blok.heading || undefined}
        stores={data ?? []}
      />
    </BlokWrap>
  );
};
